// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"EditGameStatsPage_pageContainer__2czeV","icons":"EditGameStatsPage_icons__-Hr8P","formRow":"EditGameStatsPage_formRow__NERAm"};